import { createFileRoute } from '@tanstack/react-router';
import { useEffect, useState } from 'react';
import { ExternalItemsPage } from '../features/external/external-page.tsx';
import { externalToken, noReferrer, takeTokenFromFragment } from '../features/external/token.ts';

/**
 * 21d item 5: the external participant's page (outside the workbench layout: no navigation, no session). The
 * invitation link is `/external#token=ext_…`: the fragment is read before the page renders or any query runs (so the
 * token never reaches a server log or a `Referer`), kept for this tab only and removed from the address bar.
 */
export const Route = createFileRoute('/external')({
  beforeLoad: () => {
    noReferrer();
    takeTokenFromFragment();
  },
  onLeave: () => {
    document.getElementById('wb-external-referrer')?.remove();
  },
  component: ExternalRoute,
});

function ExternalRoute() {
  const [token] = useState(() => takeTokenFromFragment() ?? externalToken());
  useEffect(() => noReferrer(), []);
  return <ExternalItemsPage token={token} />;
}
